import {取込履歴検索条件型} from '@/type/external/request/取込履歴検索条件';
import {取込ファイル型} from '@/type/external/file/取込ファイル';
import Auth from '@/infrastructure/api/helper/Auth';
import download from '@/infrastructure/api/download';
import {外部連携移動検索条件型} from '@/type/external/request/外部連携移動検索条件';
import {取込ファイル確定依頼型} from '@/type/external/request/取込ファイル確定依頼';
import {取込ファイル確定取消依頼型} from '@/type/external/request/取込ファイル確定取消依頼';
import {取込履歴一覧型} from '@/type/external/file/取込履歴一覧';
import {外部連携移動履歴一覧型} from '@/type/external/movement/外部連携移動履歴一覧';
import {取込ファイル番号型} from '@/type/external/file/取込ファイル番号型';
import {外部連携取込日付設定有無型} from '@/type/external/movement/外部連携取込日付設定有無型';

export default {
  async ファイルをアップロードする(file: any, config: any): Promise<取込ファイル番号型> {
    const auth = new Auth();
    const response = await auth.post('/api/external/movement/tosho', file, config);
    return response.data;
  },
  async 取込履歴を検索する(取込履歴検索条件: 取込履歴検索条件型): Promise<取込履歴一覧型> {
    const auth = new Auth();
    const response = await auth.post('/api/external/movement/file/history/search', 取込履歴検索条件);
    return response.data;
  },

  async 取込ファイルを取得する(ファイル取込番号: string): Promise<取込ファイル型> {
    const auth = new Auth();
    const response = await auth.get(`/api/external/movement/history/${ファイル取込番号}`);
    return response.data;
  },

  async 外部連携取込を確定する(取込ファイル確定依頼: 取込ファイル確定依頼型): Promise<void> {
    const auth = new Auth();
    await auth.post(`/api/external/movement`, 取込ファイル確定依頼);
  },

  async 外部連携取込の確定を取消する(取込ファイル確定取消依頼: 取込ファイル確定取消依頼型): Promise<void> {
    const auth = new Auth();
    const response = await auth.put('/api/external/movement/cancel/', 取込ファイル確定取消依頼);
    return response.data;
  },

  async excel出力する(ファイル取込番号: string): Promise<void> {
    const auth = new Auth();
    const response = await auth.get(`/api/external/movement/download/${ファイル取込番号}`, {responseType: 'blob'});
    const file = response.data;
    download.excelout(file, '外部連携取込ファイル一覧表.xlsx');
  },

  async 外部連携移動履歴を検索する(外部連携移動検索条件: 外部連携移動検索条件型): Promise<外部連携移動履歴一覧型> {
    const auth = new Auth();
    const response = await auth.post(`/api/external/movement/search`, 外部連携移動検索条件);
    return response.data;
  },

  async 外部連携移動履歴一覧表を出力する(検索条件: 外部連携移動検索条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post(`/api/external/movement/history/download`, 検索条件, {responseType: 'blob'});
    const file = response.data;
    download.excelout(file, '外部連携移動履歴一覧表.xlsx');
  },

  async 外部連携取込日付設定有無を取得する(): Promise<外部連携取込日付設定有無型> {
    const auth = new Auth();
    const response = await auth.get(`/api/external/movement/tosho/config-date`);
    return response.data;
  },
};
